export default __webpack_public_path__ + "static/media/bunda-mulia-university.44717c3c.png";